import incentives from './incentives';
import account from './account';
import widgetInfo from './widgetInfo';
import vcdaError from './vcdaError';

const root = {
	incentives,
	account,
	widgetInfo,
	vcdaError
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js